'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const NavView = require('balus/ui/view/body/process/nav/index');
const ContentTemplate = require('balus/ui/template/body/process-import/index.hbs');
const ImportRequestTemplate = require('balus/ui/template/body/process-import/content.hbs');
const CoverView = require('balus/ui/view/body/project/cover');
const TitleView = require('balus/ui/view/body/process-import/title');

const ActionImportService = require('process/app/service/action/import');
const ActionImportRepository = require('process/domain/repository/action/import');


const ImportRequestView = Mn.View.extend({
    template: ImportRequestTemplate,
});

module.exports = Mn.View.extend({
    className: 'row',
    template: ContentTemplate,
    ui: {
        executeButton: '.execute',
        syncButton: '.sync'
    },
    events: {
        'click @ui.executeButton': 'startExecute',
        'click @ui.syncButton': 'sync'
    },
    regions: {
        nav: '#nav',
        cover: '#cover',
        title: '#title',
        toolbar: '#toolbar',
        import: '.process-import',
    },
    modelEvents: {
        change: 'render'
    },

    onRender: function() {
        const context = this.getOption('context');
        const project = context.getProject();

        this.showChildView('cover', new CoverView({
            model: project,
            context: context.getParent(),
            process: true
        }));

        this.showChildView('title', new TitleView({
            model: context.getAction(),
            context: context
        }));

        this.showChildView('nav', new NavView({
            model: project,
            context: context.getParent(),
            target: context.getAction()
        }));

        this.showChildView('import', new ImportRequestView({
            model: this.model,
            context: context
        }));

        if (this.model.isExtracted()) {
            this.enableExecuteButton();
        }

    },

    enableExecuteButton: function() {
        this.ui.executeButton.removeClass('disabled');
    },

    disableExecuteButton: function() {
        this.ui.executeButton.addClass('disabled');
    },

    startExecute: function() {
        // ボタンが無効化されている時のクリックは無視する
        if (this.ui.executeButton.hasClass('disabled')) {
            return;
        }

        this.disableExecuteButton();

        const context = this.getOption('context');
        const project = context.getProject();
        const action = context.getAction();
        const service = new ActionImportService(project, action);

        service.execute(this.model.id).then(model => {
            this.model.set(model.attributes);
        });
    },

    sync: function() {
        const context = this.getOption('context');
        const project = context.getProject();
        const action = context.getAction();

        (new ActionImportRepository(project, action)).get(this.model.id).then(model => {
            this.model.set(model.attributes);
        });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process-import/index.js